import PropTypes from 'prop-types'
import { useId } from 'react'

import Text from 'components/Text'

import { ChoiceLabel, Input, Root } from './RadioInput.style'

const RadioInput = ({ label, name, value, checked, onChange }) => {
  const id = useId()

  return (
    <Root>
      <Input id={id} name={name} type="radio" value={value} checked={checked} onChange={() => onChange(value)} />
      <ChoiceLabel htmlFor={id}>
        <Text>{label}</Text>
      </ChoiceLabel>
    </Root>
  )
}

RadioInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

RadioInput.defaultProps = {
  label: null,
  name: null,
  value: null,
  checked: false,
  onChange: () => {},
}

export default RadioInput
